import React from 'react';
import styles from './TowerPlatform.module.scss';
import { useTranslation } from 'react-i18next';
import { HomeSectionTitle } from '../HomeSectionTitle/HomeSectionTitle';
import TowerPlatForm from '../../assets/imgs/home/img-tower-platform.png';


const TowerPlatform = () => {
    const [t] = useTranslation();

    return (
        <div className={styles.tower_platform} id="platform">
            <div className={styles.section_title}>
                <HomeSectionTitle
                    title={t('TOWER_PLATFORM_INCLUDES')}
                />
            </div>

            <div className={styles.section_body}>
                <div className={`${styles.platform_card} ${styles.tck_cdh_mobile_games}`}>
                    <div className={styles.card_title}>{t('TCK_CDH_MOBILE_GAMES')}</div>
                    <div className={styles.card_contents}>
                        <ul>
                            <li>{t('MOBILE_GAMES_DOWNLOADS')}</li>
                            <li>{t('TOWER_DEFENSE_BASED_ON_COLLECTIBLES')}</li>
                            <li style={{ width: '60%' }}>{t('PLAYERS_EARN_BY_PLAYING')}</li>
                        </ul>
                    </div>
                </div>

                <div className={`${styles.platform_card} ${styles.tower_tkn}`}>
                    <div className={styles.card_title}>{t('THE_TOWER_TOKEN')}</div>
                    <div className={styles.card_contents}>
                        <ul>
                            <li>{t('ERC_20_TOKEN_ON_ETHEREUM')}</li>
                            <li>{t('A_MEDIUM_FOR_CKF')}</li>
                            <li>{t('EARNED_BY_PLAYING_GAMES')}</li>
                            <li>{t('PURCHASE_ITEMS_PARTICIPATE_IN_GOVERNANCE_OF_GAMES')}</li>
                        </ul>
                    </div>
                </div>

                <div className={`${styles.platform_card} ${styles.blockchain_pc_game}`}>
                    <div className={styles.card_title}>{t('UPCOMING_BLOCKCHAIN_PC_GAME')}</div>
                    <div className={styles.card_contents}>
                        <ul>
                            <li>{t('NEW_GAME_UNDER_DEVELOPMENT')}</li>
                            <li>{t('NEW_GAME_ALLOWS_USERS_USE_NFTS_EARN_PARTICIPATE')}</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className={styles.tower_platform_icon}>
                <img src={TowerPlatForm} alt="tower-platform" />
            </div>
        </div>
    )
}

export {TowerPlatform}
